import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "@/lib/AuthContext";
import Logo from "@/components/Logo";
import { LayoutDashboard, Calendar, Users, FolderKanban, FileText, Image as ImgIcon, Handshake, LogOut, UserCog } from "lucide-react";

const NAV = [
  { to: "/admin", icon: LayoutDashboard, label: "Dashboard", end: true },
  { to: "/admin/eventi", icon: Calendar, label: "Eventi" },
  { to: "/admin/prenotazioni", icon: Users, label: "Prenotazioni" },
  { to: "/admin/progetti", icon: FolderKanban, label: "Progetti" },
  { to: "/admin/articoli", icon: FileText, label: "Articoli" },
  { to: "/admin/gallery", icon: ImgIcon, label: "Gallery" },
  { to: "/admin/partner", icon: Handshake, label: "Reti" },
  { to: "/admin/utenti", icon: UserCog, label: "Utenti" },
];

export default function AdminLayout() {
  const { user, logout } = useAuth();
  const nav = useNavigate();
  const handleLogout = () => { logout(); nav("/admin/login"); };

  return (
    <div className="min-h-screen bg-[#F8F1E8] flex" data-testid="admin-layout">
      <aside className="w-64 bg-[#292522] text-[#FFFCF8] p-6 hidden md:flex flex-col shrink-0">
        <Logo variant="dark" size="md" />
        <nav className="mt-8 flex flex-col gap-1">
          {NAV.map((n) => {
            const Icon = n.icon;
            return (
              <NavLink
                key={n.to}
                to={n.to}
                end={n.end}
                className={({ isActive }) =>
                  `inline-flex items-center gap-3 rounded-lg px-3 py-2.5 text-sm font-medium transition-colors ${isActive ? "bg-[#FF6100] text-white" : "text-[#FFFCF8]/75 hover:bg-[#FFFCF8]/10 hover:text-[#FFFCF8]"}`
                }
                data-testid={`admin-nav-${n.label.toLowerCase()}`}
              >
                <Icon className="h-4 w-4" strokeWidth={1.75} />
                {n.label}
              </NavLink>
            );
          })}
        </nav>
        <div className="mt-auto pt-6 border-t border-[#FFFCF8]/10 text-xs text-[#FFFCF8]/60">
          <div className="mb-3">{user?.email}</div>
          <button onClick={handleLogout} className="inline-flex items-center gap-2 text-[#FFFCF8]/80 hover:text-[#FF6100]" data-testid="admin-logout">
            <LogOut className="h-4 w-4" strokeWidth={1.75} /> Esci
          </button>
        </div>
      </aside>
      <div className="flex-1 min-w-0">
        <div className="md:hidden bg-[#292522] text-white p-4 flex items-center justify-between">
          <Logo variant="dark" size="sm" />
          <button onClick={handleLogout} className="text-xs">Esci</button>
        </div>
        <div className="md:hidden bg-[#292522] text-[#FFFCF8] px-4 pb-4 overflow-x-auto">
          <div className="flex gap-2">
            {NAV.map((n) => (
              <NavLink key={n.to} to={n.to} end={n.end} className={({ isActive }) => `px-3 py-1.5 rounded-full text-xs whitespace-nowrap ${isActive ? "bg-[#FF6100]" : "bg-[#FFFCF8]/10"}`}>{n.label}</NavLink>
            ))}
          </div>
        </div>
        <main className="p-6 lg:p-10 max-w-6xl">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
